import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'
import {LOGIN_MUTATION} from "../../queries/Queries"
import CircularProgressIndicator from '../elements/CircularProgressIndicator'
import { useMutation } from '@apollo/react-hooks';
import axios from 'axios'
import { useNavigate } from 'react-router-dom/dist';
var CryptoJS = require("crypto-js");

const Login = () => {
  const navigate = useNavigate();

  return <LoginChild navigate={navigate} />;
};

class LoginChild extends Component {
  state = {
    fields: {
      "email": `${process.env.REACT_APP_DEVELOPER === "true" ? process.env.REACT_APP_EMAIL : ""}`,
      "password": `${process.env.REACT_APP_DEVELOPER === "true" ? process.env.REACT_APP_PASSWORD : ""}`
    },
    errors: {
    }
  }



  handleChange(field, e) {
      let fields = this.state.fields; 
      fields[field] = e.target.value;
      this.setState({fields});
  }

  render() {
    
    return (
      <LoginForm 
        emailChange={this.handleChange.bind(this, "email")}
        passwordChange={this.handleChange.bind(this, "password")}
        setState={this.setState}
        state={this.state}
        onError={(errors) => this.setState({errors})}
        navigate={(url) => this.props.navigate(url)}
      />
    )
  }

}
function handleValidation(email, password) {
  let errors = {};
  let formIsValid = true;

  if(!email){
      formIsValid = false;
      errors["email"] = "Cannot be empty"
  }

  if(!password){
      formIsValid = false;
      errors["password"] = "Cannot be empty"
  }

  return {errors, formIsValid};
}
function LoginForm({ emailChange, passwordChange, state, onError, navigate}) {
  const [login, { loading, error }] = useMutation(LOGIN_MUTATION);


  if(loading) return(<CircularProgressIndicator size={60} />)
  // if(error) alert("Login Error: "+ error.message)

  // Call the login mutation when the form is submitted
  const handleSubmit = async (event) => {
    event.preventDefault();
    const email = state.fields["email"]
    const password = state.fields["password"]
    console.log(`email ${email} password ${password}`)
    let {errors, formIsValid} = handleValidation(email, password)
    onError(errors)
    if(formIsValid) {
      try {
        let encryptedPW = await Encrypt("auth."+email, password);
        let response = await login({variables: {email: email, password: encryptedPW}})
        
        if(response.data.login.jwt === undefined) {
          console.log("undefined jwt");
          return;
        }
        let token = response.data.login.jwt
        localStorage.setItem(AUTH_TOKEN, token)
        navigate(`/points-of-action-case`)
      } catch(e) {
        console.log(e)
        // alert("Login was unsuccessfull. Check credetials! Or contact admin with the console outputs [key F12 pulls it up in most browsers].")
      }
    }
  };
  
  return (
    <form method="post"
    onSubmit={ handleSubmit }>
      <div>
        <h4 className="mv3">{'Login'}</h4>
        <div className="flex flex-column">
          <input
            value={state.fields["email"]}
            onChange={emailChange}
            type="text"
            placeholder="Your email/username"
            autoComplete="email"
            autoFocus
            />
          <br/>
          <span className="error">{state.errors["email"]}</span>
          <br/>
          <input
            value={state.fields["password"]}
            onChange={passwordChange}
            type="password"
            placeholder = "Your password"
            autoComplete="password"
            />
          <br/>
          <span className="error">{state.errors["password"]}</span>
          <br/>
        </div>
        {error?.message && (
          <div className="error">
            {error.message}
          </div>
        )}
        <div className="flex mt3">
          {loading ? <CircularProgressIndicator size={60} /> : 
          <button type="submit">
              {'login'}
          </button>}
        </div>
        <br/>
      </div>
    </form>
  )
}

export async function Encrypt(reason, value) {
  const eky = process.env.CRYPTOK || "UwXPEH9gc54XkXKtr8J7nukInrHBrjz3P1Ty+Bv6QeA=";

  console.log("generate nounce")
  const response = await axios.post(process.env.REACT_APP_BACKEND_URL+"/api/nounce/generate_nounce", { reason });
  let nounce = response.data.nounce || "+LctPbVmVnEt8F2Tv0Cfog==";
  nounce = CryptoJS.enc.Base64.parse(nounce)
  
  const secretKey = CryptoJS.enc.Base64.parse(eky)
  // console.log("encrypt: " + value + " key: " + secretKey + " iv: " + nounce)
  let encrypted =  CryptoJS.AES.encrypt(value, secretKey, {
    mode: CryptoJS.mode.CBC, 
    padding: CryptoJS.pad.Pkcs7,
    iv: nounce,
  })
  
  return encrypted.toString();
    //https://stackoverflow.com/questions/25492179/decode-a-base64-string-using-cryptojs
}
 
export default Login;